import axios from "axios";
import config from "../../config";
const apiurl = config.ADMIN_BASE_URL;

const getToken = () => {
  return localStorage.getItem("cookies");
}

export const LoginAdmin = async (email, password) => {
  // console.log(data);

  try {
    console.log("apiurl", apiurl);
    const response = await axios.post(`${apiurl}/login`, { email, password });
    return response.data;
  } catch (error) {
    console.log("error", error);
    return Promise.reject(error.response.data);
  }
};

export const LogoutAdmin = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/logout`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchUserProfile = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

